// extracted by mini-css-extract-plugin
export var heading = "surgeries-module--heading--tfV77";